<template>
  <div class="recommend">
    <div class="recommend-title">
      <span class="line"></span>
      <span class="text">精选推荐</span>
      <span class="line"></span>
    </div>
    <div class="recommend-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-row gutter="10"   style="display: flex;flex-wrap: wrap;">
          <van-col span="12" v-for="(item,index) in productList" :key="index" @click="onNavigate(item)">
            <div class="item">
              <img :src="item.image" alt="goods03" width="170" height="170">
              <div class="content">
                <div class="name">{{item.name}}</div>
                <div class="footer">
                  <span class="price">￥{{item.price}}</span>
                  <img src="@/assets/mycart.png" alt="加入购物车" width="30" height="30" @click.stop="addCart(item)">
                </div>
              </div>
            </div>
          </van-col>
        </van-row>
      </van-list>
    </div>
  </div>
</template>

<script>
  import { addShopCart } from '@/api/cart'
  import { getCartRecommend,queryRecommendProduct } from '@/api/product'
  export default {
    name: "Recommend",
    data(){
      return{
        loading: false,
        finished: false,
        productList: [],
        total: 0,
        listQuery: {
          page: 1,
          limit: 10
        },
      }
    },
    created(){
      //this.getList()
    },
    methods: {
      addCart(item){
        var user = localStorage.getItem('userInfo')
        if (!user){
          this.$router.push({
            path: '/login'
          })
          return;
        }
        user = JSON.parse(user)
        const form = {
          uid: user.id,
          pid: item.id,
        }
        addShopCart(form).then(res => {
          if (res.success) {
            this.$toast({
              message: '已添加至购物车'
            })
            this.$emit('getCartList')
          }
        })
      },
      onNavigate(item) {
        this.$router.push({
          path: 'product/detail',
          query: { id: item.id }
        })
      },
      onLoad() {
        let params = {
          uid: '',
          nameList: []
        };
        var user = localStorage.getItem("userInfo")
        if (user){
          user = JSON.parse(user);
          params.uid = user.id;
        }
        var nameList = localStorage.getItem("nameList")
        if (nameList){
          nameList = JSON.parse(nameList);
          params.nameList = nameList;
        }
        this.listQuery.query = params;
        queryRecommendProduct(this.listQuery).then(res =>{
          if (res.success) {
            if (this.refreshing) {
              this.orderList = [];
              this.refreshing = false;
            }
            if (res.data.records.length==0) {
              this.finished = true;
            }else{
              res.data.records.forEach((item) => {
                this.productList.push(item);
              });
              this.loading = false
              this.listQuery.page ++;
            }

          }
        })
      },
      getList(){
        let params = {
          uid: '',
          nameList: []
        };
        var user = localStorage.getItem("userInfo")
        if (user){
          user = JSON.parse(user);
          params.uid = user.id;
        }
        var nameList = localStorage.getItem("nameList")
        if (nameList){
          nameList = JSON.parse(nameList);
          params.nameList = nameList;
        }
        getCartRecommend(params).then(res =>{
          if(res.success){
            this.productList = res.data
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .recommend{
    .recommend-title{
      height: 54px;
      font-size:16px;
      font-weight:500;
      line-height:54px;
      color:rgba(102,102,102,1);
      display: flex;
      justify-content: center;
      .line{
        width: 50px;
        border-top: 1px solid #707070;
        margin-top: 27px;
      }
      .text{
        margin: 0 30px;
      }
    }
    .recommend-content{
      padding: 10px 12px;
      background: #ffffff;
      .item{
        border:1px solid rgba(243,243,243,1);
        .name{
          height:38px;
          font-size:14px;
          font-weight:bold;
          line-height:19px;
          color:rgba(51,51,51,1);
          opacity:1;
          padding: 0 5px;
          overflow:hidden;/*超出隐藏*/
          text-overflow:ellipsis;/*文本溢出时显示省略标记*/
          display:-webkit-box;/*设置弹性盒模型*/
          -webkit-line-clamp:2;/*文本占的行数,如果要设置2行加...则设置为2*/
          -webkit-box-orient:vertical;/*子代元素垂直显示*/
        }
        .footer{
          display: flex;
          justify-content: space-between;
          .price{
            height:30px;
            font-size:16px;
            font-weight:bold;
            line-height:30px;
            color:rgba(254,0,59,1);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/cart/modules/Recommend.vue